import { BiTimer } from 'react-icons/bi';
import { lighten } from 'polished';

import { Card, ICardsProps } from '../../../../components/Card';
import { useSettings } from '../../../../hooks/settings';

export const LateOrdersCard = (
  props: Pick<ICardsProps, 'content' | 'percentage' | 'loading' | 'onClick'>
) => {
  const { cardsLoading } = useSettings();

  return (
    <Card
      title="Atrasados"
      invertPercentageColors
      icon={<BiTimer />}
      cardColor={lighten(0.325, '#FFFF00')}
      loading={cardsLoading}
      {...props}
    />
  );
};
